/* libs */
import React from "react";
import PropTypes from "prop-types";
import * as moment from "moment";

/* components */
import { TextInput } from "../../../../components/shared/Forms";

const IntegrationModuleFields = props => {
	const {
		actionType,
		connectIntegration,
		hasBeenRedirected,
		lastRefreshedAt,
		oauth: { canRefresh, errorMessage, integrationData, isLoading },
		providerName,
		refreshClick,
	} = props;

	const formattedLastRefreshedAt = moment
		.utc(lastRefreshedAt)
		.local()
		.format("YYYY-MM-DD hh:mm:ss A");

	let guessedErrorMessage;
	if (errorMessage) {
		guessedErrorMessage = ["refresh", "expire"].every(e => errorMessage.toLowerCase().includes(e))
			? "You might need to remake this integration."
			: `Something went wrong with ${actionType === "update" ? "refreshing" : "retrieving"} your tokens.`;
	}

	const isNewIntegration = actionType !== "update";

	return !hasBeenRedirected ? (
		<React.Fragment>
			<div className="m-bottom">
				<button className="btn btn-info" type="button" onClick={connectIntegration}>
					Connect to {providerName}
				</button>
			</div>
			<hr />
		</React.Fragment>
	) : (
		<React.Fragment>
			<React.Fragment>
				{actionType === "update" && canRefresh && (
					<div className="btn btn-info" onClick={refreshClick}>
						{isLoading ? "Refreshing..." : "Refresh Token"}
					</div>
				)}
				{errorMessage && (
					<div>
						<small className="text-danger">{guessedErrorMessage}</small>
					</div>
				)}
				{!isLoading && (
					<div>
						<small>Last refreshed at {formattedLastRefreshedAt}</small>
					</div>
				)}
				{!errorMessage && (
					<React.Fragment>
						<TextInput field="refreshToken" id="refreshToken" placeholder="Refresh Token" disabled={true} />
						<TextInput field="accessToken" id="accessToken" placeholder="Access Token" disabled={true} />
					</React.Fragment>
				)}
			</React.Fragment>
		</React.Fragment>
	);
};

IntegrationModuleFields.propTypes = {
	actionType: PropTypes.string.isRequired,
	connectIntegration: PropTypes.func.isRequired,
	hasBeenRedirected: PropTypes.bool.isRequired,
	lastRefreshedAt: PropTypes.string.isRequired,
	oauth: PropTypes.shape({
		canRefresh: PropTypes.bool.isRequired,
		errorMessage: PropTypes.string.isRequired,
		integrationData: PropTypes.object.isRequired,
		isLoading: PropTypes.bool.isRequired,
	}),
	providerName: PropTypes.string.isRequired,
	refreshClick: PropTypes.func.isRequired,
};

export default IntegrationModuleFields;
